import React from 'react';
import {
  LayoutDashboard,
  DollarSign,
  Flame,
  Package,
  BarChart2,
  Globe,
  TrendingUp,
  BarChart3,
  ArrowUpRight,
  Activity,
  Calculator,
} from 'lucide-react';

interface Tab {
  key: string;
  label: string;
}

interface DashboardTabNavProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  accentColor?: string;
}

function getTabIcon(label: string): React.ComponentType<{ size?: number; className?: string }> | null {
  const l = label.toLowerCase();
  if (l.includes('overview')) return LayoutDashboard;
  if (l.includes('price') || l.includes('fair')) return DollarSign;
  if (l.includes('feedstock')) return Flame;
  if (l.includes('inventory')) return Package;
  if (l.includes('demand') || l.includes('production') || l.includes('capacity')) return BarChart2;
  if (l.includes('market') || l.includes('usitc') || l.includes('export')) return Globe;
  if (l.includes('rate')) return TrendingUp;
  if (l.includes('total')) return BarChart3;
  if (l.includes('running') || l.includes('daily')) return Activity;
  if (l.includes('average')) return Calculator;
  if (l.includes('arrow') || l.includes('up')) return ArrowUpRight;
  return null;
}

const DashboardTabNav: React.FC<DashboardTabNavProps> = ({
  tabs,
  activeTab,
  onTabChange,
  accentColor,
}) => {
  return (
    <div className="flex overflow-x-auto gap-1 pb-1">
      {tabs.map((tab) => {
        const isActive = tab.key === activeTab;
        const Icon = getTabIcon(tab.label);
        return (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`
              flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap
              ${isActive
                ? 'bg-rs-green text-black'
                : 'bg-rs-jet text-rs-off-white/70 hover:bg-rs-jet-light hover:text-rs-off-white'
              }
            `}
            style={isActive && accentColor ? { backgroundColor: accentColor, color: '#0a0a0a' } : undefined}
          >
            {Icon && <Icon size={11} className="flex-shrink-0" />}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default DashboardTabNav;
